window.SubscriptionFunnel.StepAssortment = {
  updateAssortmentImageAndText(type) {
    const other = type === 'toysAndTreats' ? 'toysOnly' : 'toysAndTreats';

    // Update select-assortment step images
    const typeImg = document.getElementById(`${type}-assortment-img`);
    const otherImg = document.getElementById(`${other}-assortment-img`);
    if (typeImg && otherImg) {
      typeImg.classList.remove('display-none');
      otherImg.classList.add('display-none');
    }
  }
};
